export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";